<template>
    <div class="expiringissues">
        <b-card _title="Expiring issues">
            <AgGridVue :style="`height: 280px;width: 100%`" 
                                class="ag-theme-alpine" 
                                :columnDefs="columnDefs" 
                                :rowData="issues"
                                :defaultColDef="defaultColDef" 
                                :suppressColumnVirtualisation="false" >
            </AgGridVue>
        </b-card>
    </div>
</template>

<script>
import { API } from "@/api.js";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(window.AG_GRID_LIC);

export default {
    components: {
        AgGridVue,
    },
    data: function () {
        return {
            issues: [],
            defaultColDef: {
                sortable: true,
                filter: true,
				resizable: true, 
            },
            columnDefs: [
                { hide: true, field: "id" },
                { headerName: "Unit", field: "unit", width: '100px', filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Date", field: "ts", width: '130px', filter: 'agDateColumnFilter',valueFormatter: this.dateFormatter,filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Issue", field: "issue", width: '400px', filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] },cellClass: 'ag-left-aligned-cell',  },
            ],
        };
    },
    name: "ExpiringIssues",
    async mounted() {
        this.issues = await API.expiringIssues(this.machine ? this.machine.codice : null, this.section, this.filtro);
        // ordino per ts
        this.issues.sort((a, b) => a.ts - b.ts);
        this.issues = this.issues.map((i) => ({...i, ts: new Date(i.ts)}))
    },
    computed: {
        section(){
            return this.$store.getters.section
        },
        machine(){
            return this.$store.getters.machine
        },
    },
    props: {
        filtro: { type: Array, default: null }
    },
    watch: {
        filtro: {
            handler: async function (val) {
                console.log("filter changed",val)
                this.$nextTick(async () => {
                    this.issues = await API.expiringIssues(this.machine ? this.machine.codice : null, this.section, this.filtro);
                    this.issues = this.issues.map((i) => ({...i, ts: new Date(i.ts)}))
                })
            },
            immediate: true
        }
    },
    methods: {
        dateFormatter(params) {
            return params.value.toLocaleDateString();
        },
    },
};
</script>

<style scoped>
div.expiringissues {
    max-height: calc(100vh - 470px);
    overflow-y: auto;
    margin-bottom: 10px;
}
.col-9 {
    text-align: left;
    border-left: 1px solid #ccc;
}
.row.issue {
    border-bottom: 1px solid #ccc;
}
</style>
